import * as React from 'react'
// constants
import { REVIEW_STATUSES } from 'constants/review'
// utils
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
// types
import { IReview, IScheduledReviewer } from 'types/graphql'
// context
import { CompleteReviewBLContext } from 'containers/Review/CompleleReview/layers/BL'
import { ReviewsListBLContext } from 'containers/Review/ReviewList/layers/BL'

// types
export declare namespace NReviewDetailsBL {
  interface IContext {
    review: IReview & any
    reviewers: IScheduledReviewer[]
    reviewStatus: string
    isCurrentUserReviewer: boolean
    isDueToday: boolean
    isOverdue: boolean
    isDueTomorrow: boolean
  }
}

export const ReviewDetailsBLContext = React.createContext<NReviewDetailsBL.IContext>({} as any)

const ReviewDetailsBL: React.FunctionComponent<any> = ({ children, review: reviewForCard }) => {
  const { myScheduledReviewsFilter } = React.useContext(ReviewsListBLContext)
  const { review: reviewForActionBar } = React.useContext(CompleteReviewBLContext)

  // constants
  const review = reviewForCard || reviewForActionBar

  if (isEmpty(review)) {
    return null
  }

  const reviewers = get(review, 'scheduledReview.scheduledReviewers')
  const reviewStatus = get(review, 'status', REVIEW_STATUSES.NOT_STARTED)

  const isDueToday = moment().isSame(review.dueDate, 'day')
  const isOverdue = moment().isAfter(review.dueDate, 'day')
  const isDueTomorrow = moment(review.dueDate).diff(moment(), 'days') === 0
  const isCurrentUserReviewer = myScheduledReviewsFilter(review)

  const value = {
    isCurrentUserReviewer,
    isDueToday,
    isDueTomorrow,
    isOverdue,
    review,
    reviewers,
    reviewStatus
  }

  return <ReviewDetailsBLContext.Provider value={value}>{children}</ReviewDetailsBLContext.Provider>
}

export default ReviewDetailsBL
